import Vue from "vue";
import Vuex from "vuex";
import { auth } from "./auth";
import { oauth_client_app } from "./oauth_client_app";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    oauth_client_app,
  },
});
